import { productFamilyCodes } from 'types/productFamilyCodes';

const disallowedAddPaxProductFamilies = new Set([
  productFamilyCodes.CONTRACTOR,
  productFamilyCodes.ER_STAFF,
  productFamilyCodes.LOYALTY_COMPANIOIN,
  productFamilyCodes.MICE,
  productFamilyCodes.SNAP,
  productFamilyCodes.SNCX,
  productFamilyCodes.TFL,
  productFamilyCodes.THPASS,
  productFamilyCodes.MOMENTUM,
  productFamilyCodes.PALS,
  productFamilyCodes.BLUE_VOUCHER,
  productFamilyCodes.FIP_I
]);

export default disallowedAddPaxProductFamilies;
